import { setMonth as setMonthFns } from 'date-fns';

export default function setMonth(date: Date, month: number): Date {
  return setMonthFns(date, month);
}
